/* Polyfills */
import 'core-js/fn/array/includes'
import 'core-js/fn/array/filter'
import 'core-js/fn/array/find-index'
import 'core-js/fn/array/find'
import 'core-js/fn/array/map'
import 'core-js/fn/array/from'
import 'core-js/fn/array/sort'

import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'

import ErrorBoundary from 'components/app/ErrorBoundary'
import Raven from 'lib/raven'
import api from 'lib/api'
import configureStore from 'lib/redux/configure-store'
import App from 'components/app/App'

Raven.config(
  'https://8d0b67b545334f81820eaa1ff2ad2dfd@o110900.ingest.sentry.io/1521814',
  {
    release: process.env.REACT_APP_VERSION,
    environment: process.env.REACT_APP_CONTEXT === 'production' ? 'production' : 'staging'
    // temporarily disable logging
    // ignoreUrls: [/./]
  }
).install()

const initApp = () => {
  const store = configureStore()

  ReactDOM.render(
    <ErrorBoundary
      onActionClick={() => api.MessengerExtensions.requestCloseBrowser()}
    >
      <Provider store={store}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </Provider>
    </ErrorBoundary>,
    document.getElementById('root')
  )
}
Raven.context(() => initApp())



// WEBPACK FOOTER //
// ./src/index.js